'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

function snake(str) {
  return str.replace(/([A-Z])/g, function ($1) {
    return '-' + $1.toLowerCase();
  });
}

function getMods(mods) {
  return Object.keys(mods).filter(function (mod) {
    return mods[mod] !== undefined && mods[mod] !== null;
  }).map(function (mod) {
    return snake(mod) + '_' + mods[mod];
  });
}

function getMixes(mixes) {
  return mixes.filter(function (mix) {
    return mix;
  }).map(function (mix) {
    return ' ' + mix;
  }).join('');
}

function getArgs(args) {
  var out = {};
  args.forEach(function (arg) {
    if (typeof arg === 'string') {
      out.element = arg;
      return;
    }
    if (Array.isArray(arg)) {
      out.mixes = getMixes(arg);
      return;
    }
    if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null) {
      out.mods = getMods(arg);
      return;
    }
  });
  return out;
}

function bem() {
  var block = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];

  return function cn() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _getArgs = getArgs(args);

    var _getArgs$element = _getArgs.element;
    var element = _getArgs$element === undefined ? '' : _getArgs$element;
    var _getArgs$mixes = _getArgs.mixes;
    var mixes = _getArgs$mixes === undefined ? [] : _getArgs$mixes;
    var _getArgs$mods = _getArgs.mods;
    var mods = _getArgs$mods === undefined ? [] : _getArgs$mods;

    var namespace = element === '' ? block : block + '__' + element;
    var result = mods.reduce(function (sum, mod) {
      return sum + ' ' + namespace + '_' + mod;
    }, namespace).concat(mixes);
    return result === '' ? null : result;
  };
}

function cssm() {
  var styles = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  return function cn() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var _getArgs2 = getArgs(args);

    var _getArgs2$element = _getArgs2.element;
    var element = _getArgs2$element === undefined ? 'root' : _getArgs2$element;
    var _getArgs2$mixes = _getArgs2.mixes;
    var mixes = _getArgs2$mixes === undefined ? [] : _getArgs2$mixes;
    var _getArgs2$mods = _getArgs2.mods;
    var mods = _getArgs2$mods === undefined ? [] : _getArgs2$mods;

    var namespace = styles[element] || '';
    var result = mods.reduce(function (sum, mod) {
      var modClassName = element + '_' + mod;
      if (sum === '') {
        return styles[modClassName] || '';
      }
      var modStyle = styles[modClassName] || '';
      return sum + ' ' + modStyle;
    }, namespace).trim().concat(mixes);
    return result === '' ? null : result;
  };
}

module.exports = function catnip(initializer) {
  if ((typeof initializer === 'undefined' ? 'undefined' : _typeof(initializer)) === 'object') {
    return cssm(initializer);
  }
  return bem(initializer);
};


//////////////////
// WEBPACK FOOTER
// ./~/catnip/lib/index.js
// module id = 576
// module chunks = 1